var React = require('react');

function Stethoscope48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M42 33.875v2.101c0 .056-.023.105-.032.159.009.053.032.102.032.158 0 7.31-5.519 11.673-14.765 11.673-7.793 0-13.235-6.057-13.235-14.73v-3.33C4.315 28.519 0 7.265 0 4.263 0 1.193 3.732.142 5.938.005a.985.985 0 0 1 1.059.934 1 1 0 0 1-.933 1.06C6.023 2.001 2 2.35 2 4.263c0 3.586 4.848 23.718 13 23.718 8.152 0 13-20.132 13-23.718 0-1.924-4.021-2.262-4.062-2.264a1 1 0 0 1-.936-1.06.984.984 0 0 1 1.061-.934C26.268.142 30 1.193 30 4.263c0 3.002-4.315 24.256-14 25.643v3.33c0 7.496 4.62 12.732 11.235 12.732 4.768 0 12.765-1.257 12.765-9.675 0-.056.023-.105.032-.158-.009-.054-.032-.103-.032-.159v-2.101c-3.384-.489-6-3.378-6-6.893 0-3.856 3.14-6.995 6.999-6.995 3.86 0 7.001 3.139 7.001 6.995 0 3.514-2.616 6.403-6 6.893zm-1.001-11.889A5.003 5.003 0 0 0 36 26.982c0 2.662 2.1 4.826 4.73 4.969.087-.025.174-.054.27-.054.096 0 .182.029.27.054 2.629-.144 4.73-2.307 4.73-4.969a5.004 5.004 0 0 0-5.001-4.996z","key":1})]);
}

Stethoscope48px.displayName = "Stethoscope48px";

Stethoscope48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 47.97"};

module.exports = Stethoscope48px;

Stethoscope48px.default = Stethoscope48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/stethoscope-48px.svg
// module id = 1166
// module chunks = 0